Array.prototype.random = function () {
	return Math.floor((Math.random()*this.length));
}

function rand_id() {
	return btoa(Math.random()).substring(0,15);
}

function rand_range(min, max) {
	return Math.random() * (max - min) + min;
}

var wrappers = ['.wrapper', '.wrapper2', '.wrapper3', '.wrapper4', '.wrapper5'];
var bfsize = ['bfs', 'bfm', 'bfl', 'bfxl'];
var bfsvg = [
  'https://cdn.shopify.com/s/files/1/0424/8387/6008/files/butterfly.svg?v=1704330638',
  'https://cdn.shopify.com/s/files/1/0424/8387/6008/files/butterfly2.svg?v=1704394689',
  'https://cdn.shopify.com/s/files/1/0424/8387/6008/files/butterfly3.svg?v=1704394689',
  'https://cdn.shopify.com/s/files/1/0424/8387/6008/files/butterfly4.svg?v=1704394688',
  'https://cdn.shopify.com/s/files/1/0424/8387/6008/files/butterfly5.svg?v=1704394688'
];
var active = [];

(() => {
	release_butterfy();
	setInterval(() => {
		release_butterfy()
	}, 1800);
})();
function release_butterfy() {
	var i = wrappers.random();
	if (active.indexOf(i) != -1) {
		for(j = 0; j < 20; j++) {
			i = wrappers.random();
			if (active.indexOf(i) == -1) {
				active.push(i);
				break;
			}
		}
	} else {
		active.push(i);
	}
	const si = bfsize.random();
	let selector = wrappers[i];
	let w =  document.querySelector(selector);
	var id = rand_id();
	if (w != undefined) {
		w.insertAdjacentHTML(
			'beforeEnd',
			'<div class="butterfly butterfly'+i+' '+bfsize[si]+'" id="'+id+'"><img src="'+bfsvg[i]+'" alt=""></div>',
		);
	}
	setTimeout(() => {
		let butterfly = document.getElementById(id);
		if (butterfly != undefined) {
			butterfly.remove();
			for(k = 0; k < active.length; k++) {
				if (active[k] == i) {
					active.splice(k, 1);
					break;
				}
			}
		}
		// console.log('active: ', active);
	}, 5100);
}